"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VideoPreload = /** @class */ (function () {
    function VideoPreload(selector) {
        this.selector = selector;
        this.videos = document.querySelectorAll(this.selector);
        this.videos.forEach(function (video) {
            if (!video.autoplay) {
                video.load();
                video.pause();
            }
        });
    }
    return VideoPreload;
}());
exports.default = VideoPreload;
